export default "__VITE_ASSET__$e9IH1NL__"